import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { authenticate } from '@/slices/features/tokenSet/tokenSetSlice';
import { useAppDispatch } from '@/slices/hooks';

export const useAuthenticated = () => {
  const dispatch = useAppDispatch();
  const authenticated = useSelector((state: any) => state.tokenSet.authenticated);
  const [isLoading, setIsLoading] = useState(true);

  const isInIframe = typeof window !== 'undefined' && window !== window.top;

  useEffect(() => {
    setIsLoading(false);
  }, [authenticated]);

  const handleAuthentication = () => {
    dispatch(authenticate());
  };

  return {
    isAuthenticated: isInIframe ? false : authenticated,
    isLoading,
    handleAuthentication,
  };
};
